var render = function render(){var _vm=this,_c=_vm._self._c;return _c(require(`@/assets/icons/${_vm.name}.svg?inline`).default,_vm._b({tag:"Component",class:_vm.class_name + ' ' + _vm.size,on:{"v-on":_vm.$listeners,"click":() => _vm.$emit('click')}},'Component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }